/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as AuthCallbackRouteImport } from './routes/auth-callback'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminProductsRouteImport } from './routes/admin/products'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminAuditLogsRouteImport } from './routes/admin/audit-logs'
import { Route as AdminAnnouncementsRouteImport } from './routes/admin/announcements'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AppUpgradeRouteImport } from './routes/_app/upgrade'
import { Route as AppStatisticsRouteImport } from './routes/_app/statistics'
import { Route as AppShoppingListsRouteImport } from './routes/_app/shopping-lists'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppMealPrepRouteImport } from './routes/_app/meal-prep'
import { Route as AppItemsRouteImport } from './routes/_app/items'
import { Route as AppHouseholdsRouteImport } from './routes/_app/households'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AuthInvitationsAcceptRouteImport } from './routes/_auth/invitations.accept'
import { Route as AppShoppingListsListIdRouteImport } from './routes/_app/shopping-lists_.$listId'
import { Route as AppItemsBatchRouteImport } from './routes/_app/items_.batch'
import { Route as AppItemsItemIdRouteImport } from './routes/_app/items_.$itemId'
import { Route as AppHouseholdsHouseholdIdRouteImport } from './routes/_app/households_.$householdId'
import { Route as AppItemsGroupsGroupIdRouteImport } from './routes/_app/items_.groups.$groupId'
import { Route as AppHouseholdsHouseholdIdStorageLocationsRouteImport } from './routes/_app/households_.$householdId_.storage-locations'
import { Route as AppHouseholdsHouseholdIdProductGroupsRouteImport } from './routes/_app/households_.$householdId_.product-groups'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth-callback',
  path: '/auth-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductsRoute = AdminProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditLogsRoute = AdminAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnnouncementsRoute = AdminAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AdminRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AppUpgradeRoute = AppUpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => AppRoute,
} as any)
const AppStatisticsRoute = AppStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => AppRoute,
} as any)
const AppShoppingListsRoute = AppShoppingListsRouteImport.update({
  id: '/shopping-lists',
  path: '/shopping-lists',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppMealPrepRoute = AppMealPrepRouteImport.update({
  id: '/meal-prep',
  path: '/meal-prep',
  getParentRoute: () => AppRoute,
} as any)
const AppItemsRoute = AppItemsRouteImport.update({
  id: '/items',
  path: '/items',
  getParentRoute: () => AppRoute,
} as any)
const AppHouseholdsRoute = AppHouseholdsRouteImport.update({
  id: '/households',
  path: '/households',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AuthInvitationsAcceptRoute = AuthInvitationsAcceptRouteImport.update({
  id: '/invitations/accept',
  path: '/invitations/accept',
  getParentRoute: () => AuthRoute,
} as any)
const AppShoppingListsListIdRoute = AppShoppingListsListIdRouteImport.update({
  id: '/shopping-lists_/$listId',
  path: '/shopping-lists/$listId',
  getParentRoute: () => AppRoute,
} as any)
const AppItemsBatchRoute = AppItemsBatchRouteImport.update({
  id: '/items_/batch',
  path: '/items/batch',
  getParentRoute: () => AppRoute,
} as any)
const AppItemsItemIdRoute = AppItemsItemIdRouteImport.update({
  id: '/items_/$itemId',
  path: '/items/$itemId',
  getParentRoute: () => AppRoute,
} as any)
const AppHouseholdsHouseholdIdRoute =
  AppHouseholdsHouseholdIdRouteImport.update({
    id: '/households_/$householdId',
    path: '/households/$householdId',
    getParentRoute: () => AppRoute,
  } as any)
const AppItemsGroupsGroupIdRoute = AppItemsGroupsGroupIdRouteImport.update({
  id: '/items_/groups/$groupId',
  path: '/items/groups/$groupId',
  getParentRoute: () => AppRoute,
} as any)
const AppHouseholdsHouseholdIdStorageLocationsRoute =
  AppHouseholdsHouseholdIdStorageLocationsRouteImport.update({
    id: '/households_/$householdId_/storage-locations',
    path: '/households/$householdId/storage-locations',
    getParentRoute: () => AppRoute,
  } as any)
const AppHouseholdsHouseholdIdProductGroupsRoute =
  AppHouseholdsHouseholdIdProductGroupsRouteImport.update({
    id: '/households_/$householdId_/product-groups',
    path: '/households/$householdId/product-groups',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/auth-callback': typeof AuthCallbackRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/dashboard': typeof AppDashboardRoute
  '/households': typeof AppHouseholdsRoute
  '/items': typeof AppItemsRoute
  '/meal-prep': typeof AppMealPrepRoute
  '/settings': typeof AppSettingsRoute
  '/shopping-lists': typeof AppShoppingListsRoute
  '/statistics': typeof AppStatisticsRoute
  '/upgrade': typeof AppUpgradeRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/audit-logs': typeof AdminAuditLogsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/users': typeof AdminUsersRoute
  '/households/$householdId': typeof AppHouseholdsHouseholdIdRoute
  '/items/$itemId': typeof AppItemsItemIdRoute
  '/items/batch': typeof AppItemsBatchRoute
  '/shopping-lists/$listId': typeof AppShoppingListsListIdRoute
  '/invitations/accept': typeof AuthInvitationsAcceptRoute
  '/households/$householdId/product-groups': typeof AppHouseholdsHouseholdIdProductGroupsRoute
  '/households/$householdId/storage-locations': typeof AppHouseholdsHouseholdIdStorageLocationsRoute
  '/items/groups/$groupId': typeof AppItemsGroupsGroupIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/auth-callback': typeof AuthCallbackRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/dashboard': typeof AppDashboardRoute
  '/households': typeof AppHouseholdsRoute
  '/items': typeof AppItemsRoute
  '/meal-prep': typeof AppMealPrepRoute
  '/settings': typeof AppSettingsRoute
  '/shopping-lists': typeof AppShoppingListsRoute
  '/statistics': typeof AppStatisticsRoute
  '/upgrade': typeof AppUpgradeRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/audit-logs': typeof AdminAuditLogsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/users': typeof AdminUsersRoute
  '/households/$householdId': typeof AppHouseholdsHouseholdIdRoute
  '/items/$itemId': typeof AppItemsItemIdRoute
  '/items/batch': typeof AppItemsBatchRoute
  '/shopping-lists/$listId': typeof AppShoppingListsListIdRoute
  '/invitations/accept': typeof AuthInvitationsAcceptRoute
  '/households/$householdId/product-groups': typeof AppHouseholdsHouseholdIdProductGroupsRoute
  '/households/$householdId/storage-locations': typeof AppHouseholdsHouseholdIdStorageLocationsRoute
  '/items/groups/$groupId': typeof AppItemsGroupsGroupIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/auth-callback': typeof AuthCallbackRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/households': typeof AppHouseholdsRoute
  '/_app/items': typeof AppItemsRoute
  '/_app/meal-prep': typeof AppMealPrepRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/shopping-lists': typeof AppShoppingListsRoute
  '/_app/statistics': typeof AppStatisticsRoute
  '/_app/upgrade': typeof AppUpgradeRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/audit-logs': typeof AdminAuditLogsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/users': typeof AdminUsersRoute
  '/_app/households_/$householdId': typeof AppHouseholdsHouseholdIdRoute
  '/_app/items_/$itemId': typeof AppItemsItemIdRoute
  '/_app/items_/batch': typeof AppItemsBatchRoute
  '/_app/shopping-lists_/$listId': typeof AppShoppingListsListIdRoute
  '/_auth/invitations/accept': typeof AuthInvitationsAcceptRoute
  '/_app/households_/$householdId_/product-groups': typeof AppHouseholdsHouseholdIdProductGroupsRoute
  '/_app/households_/$householdId_/storage-locations': typeof AppHouseholdsHouseholdIdStorageLocationsRoute
  '/_app/items_/groups/$groupId': typeof AppItemsGroupsGroupIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/auth-callback'
    | '/privacy'
    | '/terms'
    | '/dashboard'
    | '/households'
    | '/items'
    | '/meal-prep'
    | '/settings'
    | '/shopping-lists'
    | '/statistics'
    | '/upgrade'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/admin/announcements'
    | '/admin/audit-logs'
    | '/admin/dashboard'
    | '/admin/products'
    | '/admin/users'
    | '/households/$householdId'
    | '/items/$itemId'
    | '/items/batch'
    | '/shopping-lists/$listId'
    | '/invitations/accept'
    | '/households/$householdId/product-groups'
    | '/households/$householdId/storage-locations'
    | '/items/groups/$groupId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/auth-callback'
    | '/privacy'
    | '/terms'
    | '/dashboard'
    | '/households'
    | '/items'
    | '/meal-prep'
    | '/settings'
    | '/shopping-lists'
    | '/statistics'
    | '/upgrade'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/admin/announcements'
    | '/admin/audit-logs'
    | '/admin/dashboard'
    | '/admin/products'
    | '/admin/users'
    | '/households/$householdId'
    | '/items/$itemId'
    | '/items/batch'
    | '/shopping-lists/$listId'
    | '/invitations/accept'
    | '/households/$householdId/product-groups'
    | '/households/$householdId/storage-locations'
    | '/items/groups/$groupId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/admin'
    | '/auth-callback'
    | '/privacy'
    | '/terms'
    | '/_app/dashboard'
    | '/_app/households'
    | '/_app/items'
    | '/_app/meal-prep'
    | '/_app/settings'
    | '/_app/shopping-lists'
    | '/_app/statistics'
    | '/_app/upgrade'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/signup'
    | '/admin/announcements'
    | '/admin/audit-logs'
    | '/admin/dashboard'
    | '/admin/products'
    | '/admin/users'
    | '/_app/households_/$householdId'
    | '/_app/items_/$itemId'
    | '/_app/items_/batch'
    | '/_app/shopping-lists_/$listId'
    | '/_auth/invitations/accept'
    | '/_app/households_/$householdId_/product-groups'
    | '/_app/households_/$householdId_/storage-locations'
    | '/_app/items_/groups/$groupId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-callback': {
      id: '/auth-callback'
      path: '/auth-callback'
      fullPath: '/auth-callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/products': {
      id: '/admin/products'
      path: '/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AdminProductsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit-logs': {
      id: '/admin/audit-logs'
      path: '/audit-logs'
      fullPath: '/admin/audit-logs'
      preLoaderRoute: typeof AdminAuditLogsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/announcements': {
      id: '/admin/announcements'
      path: '/announcements'
      fullPath: '/admin/announcements'
      preLoaderRoute: typeof AdminAnnouncementsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/upgrade': {
      id: '/_app/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof AppUpgradeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/statistics': {
      id: '/_app/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof AppStatisticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shopping-lists': {
      id: '/_app/shopping-lists'
      path: '/shopping-lists'
      fullPath: '/shopping-lists'
      preLoaderRoute: typeof AppShoppingListsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meal-prep': {
      id: '/_app/meal-prep'
      path: '/meal-prep'
      fullPath: '/meal-prep'
      preLoaderRoute: typeof AppMealPrepRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/items': {
      id: '/_app/items'
      path: '/items'
      fullPath: '/items'
      preLoaderRoute: typeof AppItemsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/households': {
      id: '/_app/households'
      path: '/households'
      fullPath: '/households'
      preLoaderRoute: typeof AppHouseholdsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/invitations/accept': {
      id: '/_auth/invitations/accept'
      path: '/invitations/accept'
      fullPath: '/invitations/accept'
      preLoaderRoute: typeof AuthInvitationsAcceptRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/shopping-lists_/$listId': {
      id: '/_app/shopping-lists_/$listId'
      path: '/shopping-lists/$listId'
      fullPath: '/shopping-lists/$listId'
      preLoaderRoute: typeof AppShoppingListsListIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/items_/batch': {
      id: '/_app/items_/batch'
      path: '/items/batch'
      fullPath: '/items/batch'
      preLoaderRoute: typeof AppItemsBatchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/items_/$itemId': {
      id: '/_app/items_/$itemId'
      path: '/items/$itemId'
      fullPath: '/items/$itemId'
      preLoaderRoute: typeof AppItemsItemIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/households_/$householdId': {
      id: '/_app/households_/$householdId'
      path: '/households/$householdId'
      fullPath: '/households/$householdId'
      preLoaderRoute: typeof AppHouseholdsHouseholdIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/items_/groups/$groupId': {
      id: '/_app/items_/groups/$groupId'
      path: '/items/groups/$groupId'
      fullPath: '/items/groups/$groupId'
      preLoaderRoute: typeof AppItemsGroupsGroupIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/households_/$householdId_/storage-locations': {
      id: '/_app/households_/$householdId_/storage-locations'
      path: '/households/$householdId/storage-locations'
      fullPath: '/households/$householdId/storage-locations'
      preLoaderRoute: typeof AppHouseholdsHouseholdIdStorageLocationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/households_/$householdId_/product-groups': {
      id: '/_app/households_/$householdId_/product-groups'
      path: '/households/$householdId/product-groups'
      fullPath: '/households/$householdId/product-groups'
      preLoaderRoute: typeof AppHouseholdsHouseholdIdProductGroupsRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppHouseholdsRoute: typeof AppHouseholdsRoute
  AppItemsRoute: typeof AppItemsRoute
  AppMealPrepRoute: typeof AppMealPrepRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppShoppingListsRoute: typeof AppShoppingListsRoute
  AppStatisticsRoute: typeof AppStatisticsRoute
  AppUpgradeRoute: typeof AppUpgradeRoute
  AppHouseholdsHouseholdIdRoute: typeof AppHouseholdsHouseholdIdRoute
  AppItemsItemIdRoute: typeof AppItemsItemIdRoute
  AppItemsBatchRoute: typeof AppItemsBatchRoute
  AppShoppingListsListIdRoute: typeof AppShoppingListsListIdRoute
  AppHouseholdsHouseholdIdProductGroupsRoute: typeof AppHouseholdsHouseholdIdProductGroupsRoute
  AppHouseholdsHouseholdIdStorageLocationsRoute: typeof AppHouseholdsHouseholdIdStorageLocationsRoute
  AppItemsGroupsGroupIdRoute: typeof AppItemsGroupsGroupIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppHouseholdsRoute: AppHouseholdsRoute,
  AppItemsRoute: AppItemsRoute,
  AppMealPrepRoute: AppMealPrepRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppShoppingListsRoute: AppShoppingListsRoute,
  AppStatisticsRoute: AppStatisticsRoute,
  AppUpgradeRoute: AppUpgradeRoute,
  AppHouseholdsHouseholdIdRoute: AppHouseholdsHouseholdIdRoute,
  AppItemsItemIdRoute: AppItemsItemIdRoute,
  AppItemsBatchRoute: AppItemsBatchRoute,
  AppShoppingListsListIdRoute: AppShoppingListsListIdRoute,
  AppHouseholdsHouseholdIdProductGroupsRoute:
    AppHouseholdsHouseholdIdProductGroupsRoute,
  AppHouseholdsHouseholdIdStorageLocationsRoute:
    AppHouseholdsHouseholdIdStorageLocationsRoute,
  AppItemsGroupsGroupIdRoute: AppItemsGroupsGroupIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthInvitationsAcceptRoute: typeof AuthInvitationsAcceptRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthInvitationsAcceptRoute: AuthInvitationsAcceptRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AdminRouteChildren {
  AdminAnnouncementsRoute: typeof AdminAnnouncementsRoute
  AdminAuditLogsRoute: typeof AdminAuditLogsRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminProductsRoute: typeof AdminProductsRoute
  AdminUsersRoute: typeof AdminUsersRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAnnouncementsRoute: AdminAnnouncementsRoute,
  AdminAuditLogsRoute: AdminAuditLogsRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminProductsRoute: AdminProductsRoute,
  AdminUsersRoute: AdminUsersRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
